<template>
  <div class="text-sm text-gray-500 text-center">
    <span>{{ $t("totalForm.progress", { step }) }}</span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ step: number }>();
</script>
<script lang="ts">
export default {};
</script>
